(function($) {

	$(window).on('scroll',stickyHeader);

	stickyHeader();

	function stickyHeader() {
		$(this).scrollTop() > 150 ? $('.header').addClass('scrolled') : $('.header').removeClass('scrolled');
	}

	$('.header__toggle').on('click',function(){
		$(this).toggleClass('active');
		if ($(this).hasClass('active')) {
			$('.header__menu').css('top','100%');
		} else {
			$('.header__menu').css('top','-100vh');
		}
	});

	$('.header__menu a').on('click',function(){
		if ($('.header__toggle').is(':visible')) {
			$('.header__toggle').trigger('click'); 
		}
	});

})( jQuery );  